export default __webpack_public_path__ + "static/media/icn_shield.e8423930.svg";